import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-prompt-link',
    templateUrl: './prompt-link.component.html',
    styleUrls: ['./prompt-link.component.scss'],
    standalone: false
})
export class PromptLinkComponent {
  constructor(
    public dialogRef: MatDialogRef<PromptLinkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onSubmit(form: { title: string; link: string }) {
    // Send the form data
    console.log('Form Data:', form);

    // Close the modal
    this.closeModal(form);
  }

  closeModal(form?: { title: string; link: string }) {
    // Logic to close the modal and pass out the form data
    console.log('Modal closed');
    this.dialogRef.close(form);
  }
}
